module.exports = __webpack_public_path__ + "static/media/IntroToGraphQL.3223595c.png";